import types from '@/vuex/administracao/actions-types'
import documentos from '@/utils/documentos'
import administracao from '@/utils/administracao'

const actions = {
  [types.ABRIR_DIALOG_EDICAO]: ({commit}) => {
    commit(types.ABRIR_DIALOG_EDICAO)
  },
  [types.FECHAR_DIALOG_EDICAO]: ({commit}) => {
    commit(types.FECHAR_DIALOG_EDICAO)
  },
  [types.GET_LISTA_ITENS_GLOSSARIO]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando vocabulário controlado' }, {root: true})
    try {
      commit(types.SET_LISTA_ITENS_GLOSSARIO, { listaItensGlossario: [] })
      let response = await administracao.getListaItensGlossario()
      response.data.forEach(item => {
        item.descricaoAssunto = item.descricaoAssunto && item.descricaoAssunto.split('-').length > 1
          ? item.descricaoAssunto.substring(item.descricaoAssunto.indexOf('-') + 1).trim()
          : item.descricaoAssunto.trim()
      })
      commit(types.SET_LISTA_ITENS_GLOSSARIO, { listaItensGlossario: response.data })
      return response.data
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os itens do vocabulário controlado' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando vocabulário controlado' }, {root: true})
    }
  },
  [types.CRIAR_ITEM_GLOSSARIO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando novo item no vocabulário controlado' }, {root: true})
    try {
      const body = {
        idTipoDocumento: payload.itemGlossario.idTipoDocumento,
        idAssunto: payload.itemGlossario.idAssunto,
        descricao: payload.itemGlossario.descricao,
        detalhamento: payload.itemGlossario.detalhamento
      }
      const response = await administracao.criarItemGlossario(body)
      commit(types.CRIAR_ITEM_GLOSSARIO, {itemGlossario: response.data})
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Novo item inserido com sucesso no vocabulário controlado' }, {root: true})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível salvar o novo item no vocabulário controlado' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando novo item no vocabulário controlado' }, {root: true})
    }
  },
  [types.EDITAR_ITEM_GLOSSARIO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Editando item do vocabulário controlado' }, {root: true})
    try {
      const body = {
        idTipoDocumento: payload.itemGlossario.idTipoDocumento,
        idAssunto: payload.itemGlossario.idAssunto,
        descricao: payload.itemGlossario.descricao,
        detalhamento: payload.itemGlossario.detalhamento
      }
      await administracao.editarItemGlossario(payload.itemGlossario.idItemGlossario, body)
      commit(types.EDITAR_ITEM_GLOSSARIO, {itemGlossario: payload.itemGlossario})
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Edição de item do vocabulário controlado realizada com sucesso' }, {root: true})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível salvar o novo item no vocabulário controlado' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Editando item do vocabulário controlado' }, {root: true})
    }
  },
  [types.EXCLUIR_ITEM_GLOSSARIO]: async ({ commit }, payload) => {
    const confirmacaoCallback = async () => {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo item do vocabulário controlado' }, {root: true})
      try {
        await administracao.excluirItemGlossario(payload.itemGlossario.idItemGlossario)
        commit(types.EXCLUIR_ITEM_GLOSSARIO, {itemGlossario: payload.itemGlossario})
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Item excluído do vocabulário controlado com sucesso' }, {root: true})
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível excluir o item do vocabulário controlado' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Excluindo item do vocabulário controlado' }, {root: true})
      }
    }
    const config = {
      textoPergunta: 'Excluir o item do vocabulário controlado?',
      textoConteudo: `O item "${payload.itemGlossario.tipoDocumento}: ${payload.itemGlossario.codigoAssunto} - ${payload.itemGlossario.descricao}" será excluído do vocabulário controlado.`,
      textoNao: 'Cancelar',
      textoSim: 'Excluir',
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  },
  [types.GET_LISTA_TIPOS_DOCUMENTO_GLOSSARIO]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de documento autorizados'}, {root: true})
    try {
      const response = await documentos.getTiposDocumentoGlossario()
      commit(types.SET_LISTA_TIPOS_DOCUMENTO, { listaTiposDocumento: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de documento autorizados' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de documento autorizados'}, {root: true})
    }
  }
}

export default actions
